export default function clusterIsSealed(cluster) {
  const sealedStates = ['SEALING', 'SEALED', 'UNSEALING'];
  return sealedStates.includes(cluster.state);
}
